import {
  useTranslate,
  IResourceComponentsProps,
  CrudFilters,
  HttpError,
} from "@pankod/refine-core";
import { useNavigation } from '../../core/customNavigation';

import {
  List,
  Table,
  TextField,
  useTable,
  getDefaultSortOrder,
  Space,
  EditButton,
  Form,
  Input,
  Icons,
  Button,
  DeleteButton,
} from "@pankod/refine-antd";
import { IUser } from "interfaces";

export const UserList: React.FC<IResourceComponentsProps> = () => {
  const t = useTranslate();
  const { create } = useNavigation()

  const { tableProps, sorter } = useTable<IUser, HttpError>({
    initialSorter: [
      {
        field: "username",
        order: "desc",
      },
    ],
  });

  return (
    <List
      title={t("menu.users")}
      pageHeaderProps={{
        extra: [
          <Button 
            key="page_header_extra_1" 
            onClick={() => create(t("menu.users"))}
          >
            +
          </Button>,
        ],
      }}
    >
      <Table
        {...tableProps}
        pagination={{
          ...tableProps.pagination,
          showSizeChanger: true,
        }}
        rowKey="id"
      >
        <Table.Column
          dataIndex="username"
          key="username"
          title={t("rooms.name")}
          render={(value) => <TextField value={value} />}
          // defaultSortOrder={getDefaultSortOrder("username", sorter)}
          // sorter
        />
        <Table.Column
          dataIndex="email"
          key="email"
          title={t("pages.login.mail")}
          render={(value) => <TextField value={value} />}
          // defaultSortOrder={getDefaultSortOrder("email", sorter)}
          // sorter
        />
        <Table.Column
          dataIndex="tel"
          key="tel"
          title={t("pages.booking.phone")}
          render={(value) => <TextField value={value} />}
          // defaultSortOrder={getDefaultSortOrder("tel", sorter)}
          // sorter
        />
        <Table.Column<IUser>
          title={t("table.actions")}
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              <EditButton hideText size="small" recordItemId={record.id} />
              <DeleteButton hideText size="small" recordItemId={record.id} />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};

